import script from "./ConfirmPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmPopup.vue?vue&type=style&index=0&id=79171ba0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79171ba0"]])

export default __exports__